var oe = Object.defineProperty;
var re = (t, e, s) => e in t ? oe(t, e, { enumerable: !0, configurable: !0, writable: !0, value: s }) : t[e] = s;
var w = (t, e, s) => re(t, typeof e != "symbol" ? e + "" : e, s);
import { reactive as x, provide as X, onMounted as ie, inject as Z, getCurrentInstance as N } from "vue";
import { A as g, f as j, R as C, M as q, B, i as T, D as U, j as ae, p as le, k as z, C as W, l as ue } from "./maps.BERRTEN0.js";
var S = /* @__PURE__ */ ((t) => (t.Active = "active", t.Sending = "sending", t.Success = "success", t.Failure = "failure", t))(S || {});
const ce = [
  g.SendForm,
  g.SendSaveSearch,
  g.SendSubscribe
], pe = [
  // TODO: add empty click here and update button component
  g.ApplyDiscount,
  g.OpenUri,
  g.OpenBookingEngine,
  g.NoAction,
  g.Dismiss
], de = [
  g.Hide
];
class he {
  constructor() {
    w(this, "dataValidators", {});
    w(this, "state", x({
      actions: [],
      buttonState: S.Active,
      stepActive: j.Main,
      stepPrevious: null,
      isFirstStep: !0,
      hideFunction: () => {
      }
    }));
  }
  get buttonState() {
    return this.state.buttonState;
  }
  get isFirstStep() {
    return this.state.isFirstStep;
  }
  get stepActive() {
    return this.state.stepActive;
  }
  get stepPrevious() {
    return this.state.stepPrevious;
  }
  initialize(e, s) {
    this.state.hideFunction = e, this.state.actions = s;
  }
  setStepActive(e, s = null) {
    this.state.stepActive = e, this.state.isFirstStep = e === j.Main, this.state.stepPrevious = s;
  }
  setDataValidator(e, s) {
    this.dataValidators[e] = s;
  }
  // accep type as generic for return
  async callHandler(e, s) {
    if (!this.state.actions) return !1;
    let n = {};
    const o = this.dataValidators[e];
    if (o && (n = await o(), !n))
      return !1;
    let r;
    const a = [
      // Some handlers will never come with a moduleId as they do not belong to any content module (dismiss, show..)
      (i) => i.kind === e,
      // Last hope, look for the None action - the default one
      (i) => i.kind === g.Fallback
    ];
    s && a.unshift((i) => i.moduleId === s);
    for (let i = 0; !r && i < a.length; i += 1)
      r = this.state.actions.find(a[i]);
    if (!r) return !1;
    let l = !1;
    return r.handler && (this.state.buttonState = S.Sending, l = await r.handler(n), this.state.buttonState = S.Active), ce.includes(e) && (this.state.stepActive = l ? j.Success : j.Failure, this.state.isFirstStep = !1), pe.includes(e) && this.callHandler(g.Hide), de.includes(e) && this.state.hideFunction(), l;
  }
  goBackToMainStep() {
    this.state.stepPrevious = this.state.stepActive, this.state.stepActive = j.Main, this.state.isFirstStep = !0;
  }
  reset() {
    this.state.buttonState = S.Active, this.state.stepActive = j.Main, this.state.isFirstStep = !0;
  }
}
function me(t, e = 1) {
  let s = t.replace("#", "");
  if (![3, 6].includes(s.length))
    return null;
  s.length === 3 && (s = s.split("").map((o) => o + o).join(""));
  const n = parseInt(s, 16);
  return `rgba(${n >> 16 & 255},${n >> 8 & 255},${n & 255},${e})`;
}
function ot(t) {
  const e = t.replace(/[-_\s]+(.)?/g, (s, n) => n ? n.toUpperCase() : "");
  return e.substring(0, 1).toUpperCase() + e.substring(1);
}
function fe(t) {
  return t.replace(/([a-z])([A-Z])/g, "$1-$2").replace(/[\s_]+/g, "-").toLowerCase();
}
const rt = (t) => t.replace(/[A-Z]/g, (e) => `_${e.toLowerCase()}`);
function ge(t) {
  switch ((t == null ? void 0 : t.kind) || C.Rounded) {
    case C.Custom:
      const s = t;
      return `${s.value}${s.format}`;
    case C.Square:
      return "0px";
    case C.Medium:
      return "6px";
    case C.Rounded:
    default:
      return "16px";
  }
}
function be(t = 0) {
  return `${t}px`;
}
function it(t = 0) {
  return `${t}%`;
}
function at(t = 0) {
  return `${t}em`;
}
function R(t) {
  return `${t * 6 / 100}em`;
}
function we({
  format: t,
  top: e,
  right: s,
  bottom: n,
  left: o
}) {
  switch (t) {
    case q.Pixels:
      return `${e}${t} ${s}${t} ${n}${t} ${o}${t}`;
    case q.Em:
    default:
      return `${R(e)} ${R(s)} ${R(n)} ${R(o)}`;
  }
}
function $e(t) {
  return (t == null ? void 0 : t.constructor) === Object;
}
function L(t, e = 2) {
  return t.toFixed(0).padStart(e, "0");
}
function lt(t) {
  if (t < 0)
    return {
      hours: "00",
      minutes: "00",
      seconds: "00"
    };
  const e = Math.floor(t / 60), s = Math.floor(e / 60), n = Math.floor(s / 24), o = {
    // Warn: order of key-values of the object *is* critical for display
    days: L(n),
    hours: L(s % 24),
    minutes: L(e % 60),
    seconds: L(t % 60)
  };
  return n ? delete o.seconds : delete o.days, o;
}
var v = {};
Object.defineProperty(v, "__esModule", { value: !0 });
v.TokenData = void 0;
v.parse = F;
v.compile = Ee;
v.match = Ae;
v.pathToRegexp = Me;
const Te = "/", H = (t) => t, ve = new RegExp("^\\p{XID_Continue}$", "u"), A = "https://git.new/pathToRegexpError", ye = {
  "!": "!",
  "@": "@",
  ";": ";",
  ",": ",",
  "*": "*",
  "+": "+",
  "?": "?",
  "{": "{",
  "}": "}"
};
function ke(t) {
  const e = [...t], s = [];
  let n = 0;
  for (; n < e.length; ) {
    const o = e[n], r = ye[o];
    if (r) {
      s.push({ type: r, index: n++, value: o });
      continue;
    }
    if (o === "\\") {
      s.push({ type: "ESCAPED", index: n++, value: e[n++] });
      continue;
    }
    if (o === ":") {
      let a = "";
      for (; ve.test(e[++n]); )
        a += e[n];
      if (!a)
        throw new TypeError(`Missing parameter name at ${n}`);
      s.push({ type: "NAME", index: n, value: a });
      continue;
    }
    if (o === "(") {
      const a = n++;
      let l = 1, i = "";
      if (e[n] === "?")
        throw new TypeError(`Pattern cannot start with "?" at ${n}`);
      for (; n < e.length; ) {
        if (e[n] === "\\") {
          i += e[n++] + e[n++];
          continue;
        }
        if (e[n] === ")") {
          if (l--, l === 0) {
            n++;
            break;
          }
        } else if (e[n] === "(" && (l++, e[n + 1] !== "?"))
          throw new TypeError(`Capturing groups are not allowed at ${n}`);
        i += e[n++];
      }
      if (l)
        throw new TypeError(`Unbalanced pattern at ${a}`);
      if (!i)
        throw new TypeError(`Missing pattern at ${a}`);
      s.push({ type: "PATTERN", index: n, value: i });
      continue;
    }
    s.push({ type: "CHAR", index: n, value: e[n++] });
  }
  return s.push({ type: "END", index: n, value: "" }), new je(s);
}
class je {
  constructor(e) {
    this.tokens = e, this.index = 0;
  }
  peek() {
    return this.tokens[this.index];
  }
  tryConsume(e) {
    const s = this.peek();
    if (s.type === e)
      return this.index++, s.value;
  }
  consume(e) {
    const s = this.tryConsume(e);
    if (s !== void 0)
      return s;
    const { type: n, index: o } = this.peek();
    throw new TypeError(`Unexpected ${n} at ${o}, expected ${e}: ${A}`);
  }
  text() {
    let e = "", s;
    for (; s = this.tryConsume("CHAR") || this.tryConsume("ESCAPED"); )
      e += s;
    return e;
  }
  modifier() {
    return this.tryConsume("?") || this.tryConsume("*") || this.tryConsume("+");
  }
}
class D {
  constructor(e, s) {
    this.tokens = e, this.delimiter = s;
  }
}
v.TokenData = D;
function F(t, e = {}) {
  const { encodePath: s = H, delimiter: n = s(Te) } = e, o = [], r = ke(t);
  let a = 0;
  do {
    const l = r.text();
    l && o.push(s(l));
    const i = r.tryConsume("NAME"), p = r.tryConsume("PATTERN");
    if (i || p) {
      o.push({
        name: i || String(a++),
        pattern: p
      });
      const u = r.peek();
      if (u.type === "*")
        throw new TypeError(`Unexpected * at ${u.index}, you probably want \`/*\` or \`{/:foo}*\`: ${A}`);
      continue;
    }
    if (r.tryConsume("*")) {
      o.push({
        name: String(a++),
        pattern: `(?:(?!${E(n)}).)*`,
        modifier: "*",
        separator: n
      });
      continue;
    }
    if (r.tryConsume("{")) {
      const u = r.text(), c = r.tryConsume("NAME"), d = r.tryConsume("PATTERN"), m = r.text(), h = r.tryConsume(";") && r.text();
      r.consume("}");
      const f = r.modifier();
      o.push({
        name: c || (d ? String(a++) : ""),
        prefix: s(u),
        suffix: s(m),
        pattern: d,
        modifier: f,
        separator: h
      });
      continue;
    }
    r.consume("END");
    break;
  } while (!0);
  return new D(o, n);
}
function Ee(t, e = {}) {
  const s = t instanceof D ? t : F(t, e);
  return Se(s, e);
}
function Ce(t, e) {
  if (typeof t == "string")
    return () => t;
  const s = e || H, n = t.modifier === "+" || t.modifier === "*", o = t.modifier === "?" || t.modifier === "*", { prefix: r = "", suffix: a = "", separator: l = a + r } = t;
  if (e && n) {
    const p = (c, d) => {
      if (typeof c != "string")
        throw new TypeError(`Expected "${t.name}/${d}" to be a string`);
      return s(c);
    }, u = (c) => {
      if (!Array.isArray(c))
        throw new TypeError(`Expected "${t.name}" to be an array`);
      return c.length === 0 ? "" : r + c.map(p).join(l) + a;
    };
    return o ? (c) => {
      const d = c[t.name];
      return d == null ? "" : d.length ? u(d) : "";
    } : (c) => {
      const d = c[t.name];
      return u(d);
    };
  }
  const i = (p) => {
    if (typeof p != "string")
      throw new TypeError(`Expected "${t.name}" to be a string`);
    return r + s(p) + a;
  };
  return o ? (p) => {
    const u = p[t.name];
    return u == null ? "" : i(u);
  } : (p) => {
    const u = p[t.name];
    return i(u);
  };
}
function Se(t, e) {
  const { encode: s = encodeURIComponent, loose: n = !0, validate: o = !0, strict: r = !1 } = e, a = G(e), l = _(n, t.delimiter), i = Q(t, l, [], a, r), p = t.tokens.map((u, c) => {
    const d = Ce(u, s);
    if (!o || typeof u == "string")
      return d;
    const m = new RegExp(`^${i[c]}$`, a);
    return (h) => {
      const f = d(h);
      if (!m.test(f))
        throw new TypeError(`Invalid value for "${u.name}": ${JSON.stringify(f)}`);
      return f;
    };
  });
  return function(u = {}) {
    let c = "";
    for (const d of p)
      c += d(u);
    return c;
  };
}
function Ae(t, e = {}) {
  const { decode: s = decodeURIComponent, loose: n = !0 } = e, o = t instanceof D ? t : F(t, e), r = _(n, o.delimiter), a = [], l = J(o, a, e), i = a.map((p) => {
    if (s && (p.modifier === "+" || p.modifier === "*")) {
      const { prefix: u = "", suffix: c = "", separator: d = c + u } = p, m = new RegExp(r(d), "g");
      return (h) => h.split(m).map(s);
    }
    return s || H;
  });
  return function(p) {
    const u = l.exec(p);
    if (!u)
      return !1;
    const { 0: c, index: d } = u, m = /* @__PURE__ */ Object.create(null);
    for (let h = 1; h < u.length; h++) {
      if (u[h] === void 0)
        continue;
      const f = a[h - 1], b = i[h - 1];
      m[f.name] = b(u[h]);
    }
    return { path: c, index: d, params: m };
  };
}
function E(t) {
  return t.replace(/([.+*?^${}()[\]|/\\])/g, "\\$1");
}
function xe(t, e) {
  const s = E(t);
  return e ? `(?:${s})+(?!${s})` : s;
}
function _(t, e) {
  if (!t)
    return E;
  const s = new RegExp(`(?:(?!${E(e)}).)+|(.)`, "g");
  return (n) => n.replace(s, xe);
}
function G(t) {
  return t.sensitive ? "" : "i";
}
function J(t, e, s) {
  const { trailing: n = !0, loose: o = !0, start: r = !0, end: a = !0, strict: l = !1 } = s, i = G(s), p = _(o, t.delimiter), u = Q(t, p, e, i, l);
  let c = r ? "^" : "";
  return c += u.join(""), n && (c += `(?:${p(t.delimiter)})?`), c += a ? "$" : `(?=${E(t.delimiter)}|$)`, new RegExp(c, i);
}
function Q(t, e, s, n, o) {
  const r = `(?:(?!${E(t.delimiter)}).)+?`;
  let a = "", l = !0;
  return t.tokens.map((i, p) => {
    if (typeof i == "string")
      return a = i, e(i);
    const { prefix: u = "", suffix: c = "", separator: d = c + u, modifier: m = "" } = i, h = e(u), f = e(c);
    if (i.name) {
      const b = i.pattern ? `(?:${i.pattern})` : r, k = De(b, i.name, n);
      if (l || (l = I(k, u || a)), !l)
        throw new TypeError(`Ambiguous pattern for "${i.name}": ${A}`);
      if (l = !o || I(k, c), a = "", s.push(i), m === "+" || m === "*") {
        const M = m === "*" ? "?" : "", K = e(d);
        if (!K)
          throw new TypeError(`Missing separator for "${i.name}": ${A}`);
        if (l || (l = !o || I(k, d)), !l)
          throw new TypeError(`Ambiguous pattern for "${i.name}" separator: ${A}`);
        return l = !o, `(?:${h}(${b}(?:${K}${b})*)${f})${M}`;
      }
      return `(?:${h}(${b})${f})${m}`;
    }
    return `(?:${h}${f})${m}`;
  });
}
function De(t, e, s) {
  try {
    return new RegExp(`^${t}$`, s);
  } catch (n) {
    throw new TypeError(`Invalid pattern for "${e}": ${n.message}`);
  }
}
function I(t, e) {
  return e ? !t.test(e) : !1;
}
function Me(t, e = {}) {
  const s = t instanceof D ? t : F(t, e), n = [], o = J(s, n, e);
  return Object.assign(o, { keys: n });
}
var ze = typeof global == "object" && global && global.Object === Object && global, Re = typeof self == "object" && self && self.Object === Object && self, Le = ze || Re || Function("return this")(), O = Le.Symbol;
O && O.toStringTag;
O && O.toStringTag;
var Oe = Function.prototype, Fe = Oe.toString;
Fe.call(Object);
const y = ({
  langCode: t,
  mapper: e,
  number: s,
  keysLength: n
}) => {
  if (s === 0) return 0;
  const o = new Intl.PluralRules(t).select(s), r = e[o];
  return Math.min(
    n <= Object.keys(e).length ? r - 1 : r,
    n - 1
  );
}, Ie = (t, e) => y({
  langCode: "en-EN",
  mapper: { one: 1, other: 2 },
  number: t,
  keysLength: e
}), Pe = (t, e) => {
  const s = new Intl.PluralRules("ar-EG").select(t), n = {
    zero: 0,
    one: 1,
    two: 2,
    few: 3,
    many: 4,
    other: 5
  }[s];
  return Math.min(n, e - 1);
}, P = (t, e) => y({
  langCode: "ru-RU",
  mapper: { one: 1, few: 2, many: 3 },
  number: t,
  keysLength: e
}), Ve = (t, e) => y({
  langCode: "ro-RO",
  mapper: { one: 1, few: 2, other: 3 },
  number: t,
  keysLength: e
}), Ue = (t, e) => y({
  langCode: "pl-PL",
  mapper: { one: 1, few: 2, many: 3 },
  number: t,
  keysLength: e
}), Ne = (t, e) => y({
  langCode: "is-IS",
  mapper: { one: 1, other: 2 },
  number: t,
  keysLength: e
}), He = (t, e) => y({
  langCode: "hr-HR",
  mapper: { one: 1, few: 2, other: 3 },
  number: t,
  keysLength: e
}), _e = (t, e) => y({
  langCode: "cs-CZ",
  mapper: { one: 1, few: 2, other: 3 },
  number: t,
  keysLength: e
}), $ = () => 0, Ke = {
  ar: Pe,
  cs: _e,
  hr: He,
  id: $,
  is: Ne,
  ja: $,
  ko: $,
  lt: P,
  pl: Ue,
  ro: Ve,
  ru: P,
  uk: P,
  th: $,
  vi: $,
  zh: $,
  "zh-TW": $
};
function Xe(t, e, s, n, o) {
  return (Ke[t || "en"] ?? Ie)(e, 2) ? s : s.replace(o, n);
}
function V(t) {
  const e = /^(&|&amp;|a|an|and|as|at|but|by|en|for|if|in|nor|of|on|or|per|the|to|v.?|vs.?|via)$/i, s = /([A-Za-z0-9\u00C0-\u00FF])/, n = /([ :–—-])/;
  return t.split(n).map((o, r, a) => o.search(e) > -1 && r !== 0 && r !== a.length - 1 && a[r - 3] !== ":" && a[r + 1] !== ":" && (a[r + 1] !== "-" || a[r - 1] === "-" && a[r + 1] === "-") ? o.toLowerCase() : o.substring(1).search(/[A-Z]|\../) > -1 || a[r + 1] === ":" && a[r + 2] !== "" ? o : o.replace(s, (l) => l.toUpperCase())).join("");
}
function Ze(t, e) {
  switch (t) {
    case "opacity":
      return (parseInt(e, 10) / 100).toString();
    case "thickness":
      return be(parseInt(e, 10));
    case "cssName":
      return `'${e}'`;
    default:
      return e;
  }
}
function qe(t, e) {
  switch (t) {
    case "cornerRadius":
      return ge(e);
    case "padding":
      return we(e);
    default:
      return null;
  }
}
function Y(t, e) {
  return Object.keys(t).reduce((s, n) => {
    var r;
    let o = Ze(n, (r = t[n]) == null ? void 0 : r.toString());
    return $e(t[n]) && (o = qe(n, t[n]), !o) ? {
      ...s,
      ...Y(t[n], `${e}-${n}`)
    } : (s[`${e}-${fe(n)}`] = o, s);
  }, {});
}
class Be {
  constructor() {
    w(this, "rootDom", null);
    w(this, "state", x({
      colors: {},
      fonts: {},
      button: {},
      background: {},
      overlay: {}
    }));
  }
  get rootElement() {
    return this.rootDom;
  }
  get fonts() {
    return this.state.fonts;
  }
  get backgroundImage() {
    var e, s;
    return (s = (e = this.state.background.image) == null ? void 0 : e.urls) == null ? void 0 : s.edited;
  }
  get backgroundImageAlt() {
    var e;
    return (e = this.state.background.image) == null ? void 0 : e.alt;
  }
  get colors() {
    return this.state.colors;
  }
  get button() {
    return this.state.button;
  }
  initialize(e, s) {
    var o, r, a, l, i, p, u, c, d, m, h, f, b, k, M;
    this.rootDom = s, this.state.colors = e.colors || {}, this.state.fonts = e.fonts || {}, this.state.button = e.button || {}, this.state.background = e.background || {}, this.state.overlay = e.overlay || {};
    const n = Y(this.state, "--thn-tool");
    this.addCssVariables({
      ...n,
      "--thn-tool-colors-icon-back": me(((o = e.colors) == null ? void 0 : o.icon) || "#000000", 0.15),
      "--thn-tool-colors-background": (a = (r = e.colors) == null ? void 0 : r.background) != null && a.gradient ? `linear-gradient(to right bottom, ${(i = (l = e.colors) == null ? void 0 : l.background) == null ? void 0 : i.base}, ${(u = (p = e.colors) == null ? void 0 : p.background) == null ? void 0 : u.gradient})` : (d = (c = e.colors) == null ? void 0 : c.background) == null ? void 0 : d.base,
      "--thn-tool-button-background-color": ((m = e.button) == null ? void 0 : m.style) === B.Solid ? (h = e.colors) == null ? void 0 : h.buttonBackground : "transparent",
      "--thn-tool-button-border": ((f = e.button) == null ? void 0 : f.style) === B.Outline ? `solid 2px ${(b = e.colors) == null ? void 0 : b.buttonBackground}` : "transparent",
      "--thn-tool-background-border": (M = (k = e.background) == null ? void 0 : k.border) != null && M.color ? `solid ${n["--thn-tool-background-border-thickness"]} ${e.background.border.color}` : "none"
    });
  }
  addCssVariables(e) {
    Object.keys(e).forEach((s) => {
      var n;
      (n = this.rootDom) == null || n.style.setProperty(s, e[s] || "");
    });
  }
  getCssVariableValue(e) {
    return this.rootDom && getComputedStyle(this.rootDom).getPropertyValue(e);
  }
}
const We = (t, e, s) => {
  const n = t[e];
  return n ? typeof n == "function" ? n() : Promise.resolve(n) : new Promise((o, r) => {
    (typeof queueMicrotask == "function" ? queueMicrotask : setTimeout)(
      r.bind(
        null,
        new Error(
          "Unknown variable dynamic import: " + e + (e.split("/").length !== s ? ". Note that variables only represent file names one level deep." : "")
        )
      )
    );
  });
};
class Ge {
  constructor() {
    w(this, "state", x({
      language: T.English,
      device: U.Desktop,
      literals: {}
    }));
  }
  get device() {
    return this.state.device;
  }
  get language() {
    return this.state.language;
  }
  async initialize(e, s) {
    this.state.language = e ?? T.English, this.state.device = s ?? U.Desktop;
    const n = await We(/* @__PURE__ */ Object.assign({ "../locales/ar.json": () => import("./ar.SNH4kxCF.js"), "../locales/bg.json": () => import("./bg.CfYZQBQp.js"), "../locales/ca.json": () => import("./ca.v5PgSxTO.js"), "../locales/cs.json": () => import("./cs.58gISCQB.js"), "../locales/da.json": () => import("./da.BUDBFY61.js"), "../locales/de.json": () => import("./de.DVUEi71e.js"), "../locales/el.json": () => import("./el.BM6ZiQF9.js"), "../locales/en.json": () => import("./en.DK76Do-Q.js"), "../locales/es.json": () => import("./es.BvklD4vy.js"), "../locales/et.json": () => import("./et.sacry5z_.js"), "../locales/eu.json": () => import("./eu.B2zG8iyq.js"), "../locales/fi.json": () => import("./fi.tMWYvd0U.js"), "../locales/fr.json": () => import("./fr.BM39FQ3u.js"), "../locales/he.json": () => import("./he.BiPfcWoZ.js"), "../locales/hr.json": () => import("./hr.DX3BX6y9.js"), "../locales/hu.json": () => import("./hu.bceCPavx.js"), "../locales/id.json": () => import("./id.DTdrs96H.js"), "../locales/is.json": () => import("./is.B9o9yJJR.js"), "../locales/it.json": () => import("./it.YxOyOayb.js"), "../locales/ja.json": () => import("./ja.CbQl7y5d.js"), "../locales/ko.json": () => import("./ko.BJZ9N5tf.js"), "../locales/lt.json": () => import("./lt.Hy6rc0Xv.js"), "../locales/nl.json": () => import("./nl.lnaMC6Y5.js"), "../locales/no.json": () => import("./no.OgpDNGD-.js"), "../locales/pl.json": () => import("./pl.DCeDLIuf.js"), "../locales/pt.json": () => import("./pt.CvkIUuV4.js"), "../locales/ro.json": () => import("./ro.CxtnLzG6.js"), "../locales/ru.json": () => import("./ru.Z5guIC5o.js"), "../locales/sk.json": () => import("./sk.CkLYAVDb.js"), "../locales/sl.json": () => import("./sl.Ci9JJt-V.js"), "../locales/sv.json": () => import("./sv.DP5F19Su.js"), "../locales/th.json": () => import("./th.HF4eOMvB.js"), "../locales/tr.json": () => import("./tr.CKOL_mIj.js"), "../locales/uk.json": () => import("./uk.AP9G4gIL.js"), "../locales/vi.json": () => import("./vi.CnrhVwl9.js"), "../locales/zh-TW.json": () => import("./zh-TW.ByjvkRH8.js"), "../locales/zh.json": () => import("./zh.h1oDpHUT.js") }), `../locales/${this.state.language}.json`, 3);
    this.state.literals = n.default;
  }
  getLiteral(e, s) {
    return s ? V(this.state.literals[e] || e) : this.state.literals[e] || e;
  }
  getLiteralAbb(e, s) {
    const n = `${e}_abbr`;
    return this.getLiteral(n, s);
  }
  getActivityLiteral(e, s = {}) {
    const n = s[e], o = Xe(
      this.state.language,
      Number(n),
      this.state.literals[ae[e]],
      this.state.literals.Hour,
      this.state.literals.Hours
    );
    return n ? o == null ? void 0 : o.replace("XXXXXX", n) : o;
  }
  getPerkActiveLiteral(e, s = !1) {
    const n = e[this.state.language] ?? "";
    return s ? V(n) : n;
  }
  getPerkTooltipLiteral(e) {
    return this.state.literals[le[e]];
  }
  getActiveModuleText(e, s = !1, n) {
    let o = e[this.device][this.language] ?? "";
    if (n) {
      const { candidates: r = [], replacement: a = {} } = n;
      r.forEach((l) => {
        const i = a[l];
        if (!i)
          throw Error("The tool cannot be shown if any of the tokens do not have a correct replacement value");
        o = o.replaceAll(`{${l}}`, i);
      });
    }
    return s ? V(o) : o;
  }
  getLocaleImageUrl(e) {
    var s;
    switch (e.languageType) {
      case z.Multi:
        return (s = e.urls[this.language || T.English]) == null ? void 0 : s.edited;
      case z.Single:
      default:
        return e.urls.edited;
    }
  }
  getLocaleImageAlt(e) {
    switch (e.languageType) {
      case z.Multi:
        return e.alt[this.language || T.English];
      case z.Single:
      default:
        return e.alt;
    }
  }
}
class Je {
  constructor() {
    w(this, "initTime", Date.now());
    w(this, "state", x({
      builderMode: !1,
      firstVisitDate: null,
      hotelTimezone: "Europe/Madrid",
      defaultAssets: void 0,
      countdownTimestamp: void 0,
      tokens: {},
      dynamicTags: []
    }));
  }
  get countdownInitTime() {
    return this.initTime;
  }
  get builderMode() {
    return this.state.builderMode;
  }
  get defaultAssets() {
    return this.state.defaultAssets;
  }
  get countdownTimestamp() {
    return this.state.countdownTimestamp;
  }
  get tokens() {
    return this.state.tokens;
  }
  get dynamicTags() {
    return this.state.dynamicTags;
  }
  initialize(e) {
    this.state.builderMode = !!e.builderMode, this.state.firstVisitDate = e.firstVisitDate, this.state.hotelTimezone = e.hotelTimezone, this.state.hotelTimezoneOffset = e.hotelTimezoneOffset, this.state.defaultAssets = e.defaultAssets, this.state.countdownTimestamp = e.countdownTimestamp, this.state.tokens = e.tokens, this.state.dynamicTags = e.dynamicTags;
  }
  getCountdownTimestamp(e, s) {
    const {
      date: n = Date.now(),
      timezone: o,
      days: r = 0,
      hours: a = 0,
      minutes: l = 0
    } = s;
    if (this.initTime = Date.now(), e === W.Time) {
      const i = r * 24 * 60 * 60 * 1e3, p = a * 60 * 60 * 1e3, u = l * 60 * 1e3, c = this.state.firstVisitDate ? this.initTime - this.state.firstVisitDate : 0;
      return this.initTime + i + p + u - c;
    }
    if (e === W.Date && n) {
      const i = new Date(n);
      if (i.setHours(a), i.setMinutes(l), o === ue.Hotel)
        if (!this.state.hotelTimezoneOffset && this.state.hotelTimezone) {
          const p = (/* @__PURE__ */ new Date()).toLocaleString("en-US", {
            timeZone: this.state.hotelTimezone
          }), c = new Date(p).getTime() - (/* @__PURE__ */ new Date()).getTime();
          i.setTime(i.getTime() - c);
        } else this.state.hotelTimezoneOffset && i.setTime(i.getTime() - this.state.hotelTimezoneOffset);
      return i.getTime();
    }
    return null;
  }
}
const ee = new Ge(), te = {}, ne = {};
function se() {
  const t = N();
  return (t == null ? void 0 : t.uid) || 0;
}
function Qe() {
  var e;
  const t = N();
  return (e = t == null ? void 0 : t.proxy) == null ? void 0 : e.$el;
}
function Ye(t) {
  var n;
  const e = N(), s = (n = e == null ? void 0 : e.exposed) == null ? void 0 : n.hide;
  t.inited = !0, t.hideFunction = s || (() => {
  });
}
function et(t) {
  const e = se(), s = Qe(), n = te[e];
  if (n.inited)
    n.language = t.language, n.rtl = t.language === T.Arabic || t.language === T.Hebrew, n.device = t.device, n.extraData.initialize(t.extraData), n.handlers.initialize(n.hideFunction, t.actions), n.literals.initialize(t.language, t.device), n.styles.initialize(t.styles, s);
  else
    throw new Error(`error updating store ${e}: store not inited`);
}
function ut(t) {
  const e = se(), s = Symbol("useStore injection key"), n = x({
    uid: e,
    inited: !1,
    language: T.English,
    device: U.Desktop,
    hideFunction: () => {
    },
    extraData: new Je(),
    handlers: new he(),
    literals: ee,
    styles: new Be()
  });
  return te[e] = n, ne[e] = s, X(s, n), X("rootUID", e), ie(() => {
    Ye(n), et(t);
  }), n;
}
function ct() {
  const t = Z("rootUID");
  if (t !== void 0)
    return Z(ne[t]);
  throw new Error("No UID found to load the store");
}
function pt() {
  return ee;
}
export {
  S as B,
  We as _,
  fe as a,
  ge as b,
  rt as c,
  be as d,
  it as e,
  at as f,
  Xe as g,
  me as h,
  we as i,
  $e as j,
  lt as k,
  V as l,
  ut as m,
  ct as n,
  pt as o,
  L as p,
  ot as t,
  et as u
};
//# sourceMappingURL=useStore.Dhhyxhjv.js.map
